import { ComponentLocatorMap } from '../types/ComponentLocatorMap';

export const dropzoneComponent = {
  activeText: 'dropzone.active-text',
  fileInput: 'dropzone.file-input',
  inactiveText: 'dropzone.inactive-text',
  root: 'dropzone.root',
} as const satisfies ComponentLocatorMap;
